import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb5e1df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }

import BaseButton from '@/components/BaseButton.vue'
import { FORMATS, SIZES } from '@/enums/components'
import { PropType } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoWindowContent',
  props: {
  services: {
    type: Array as PropType<PublicService[]>,
    required: true,
  },
  disableRoutePlanning: {
    type: Boolean,
    default: false,
  },
  onAdd: Function,
},
  setup(__props) {



function handleLinkClick(service: PublicService) {
  window.open(service.public_url, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (service) => {
      return (_openBlock(), _createElementBlock("div", {
        key: service.id,
        class: "service"
      }, [
        _createVNode(BaseButton, {
          label: service.name,
          size: _unref(SIZES).SMALL,
          format: _unref(FORMATS).TERTIARY,
          onOnClick: () => handleLinkClick(service)
        }, null, 8, ["label", "size", "format", "onOnClick"]),
        (!__props.disableRoutePlanning)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              label: "Lisa teekonda",
              size: _unref(SIZES).SMALL,
              onOnClick: () => __props.onAdd(service)
            }, null, 8, ["size", "onOnClick"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})